define ['./../applications/applications.scss'], () ->
  ($scope, $rootScope, $state, $stateParams, $http, RENTAPPLICATION_API_URL, Application) ->
    shareToken = $stateParams.shareToken

    $scope.go_to_correct_page = () ->
      Application.get(id: $stateParams.application_id).$promise
        .then (response) ->
          $scope.application = response

          if _.find($scope.application.reports, (o) -> o.source_identifier == 'mvga_employment_plus' and o.status == 'sent_payment_request')
            $scope.display_progress_bar = true
            $state.go('root.payment.income')
          else if !_.find($scope.application.reports, (o) -> o.status == 'sent_payment_request')
            $state.go "root.payment.complete"
          else
            $state.go "root.payment.pay"
        .catch (err) ->
          $state.go "root.home.403"


    if shareToken
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/login/", shareToken: shareToken
      .then (response) ->
        $scope.go_to_correct_page()
      .catch (err) ->
        console.log "bad share token", shareToken
        $state.go $state.current.name, {application_id: $stateParams.application_id, shareToken: null}
    else
      $scope.go_to_correct_page()

    $scope.display_progress_bar = false

    step1_green_svg = require('./../../images/step1-green.svg')
    step1_gray_svg = require('./../../images/step1-gray.svg')
    step2_green_svg = require('./../../images/step2-green.svg')
    step2_gray_svg = require('./../../images/step2-gray.svg')
    step3_green_svg = require('./../../images/step3-green.svg')
    step3_gray_svg = require('./../../images/step3-gray.svg')
    step_complete_svg = require('./../../images/step-complete.svg')
    step_failed_svg = require('./../../images/step-failed.svg')

    $scope.step1 = step1_green_svg
    $scope.step2 = step2_gray_svg
    $scope.step3 = step3_gray_svg

    $scope.steps_mapping = [
      'root.payment.income',
      'root.payment.pay',
      'root.payment.complete'
    ]

    $scope.$watch(() ->
      $state.$current.name
    , (newVal, oldVal) ->
      $scope.current_state = newVal
      $scope.set_active(newVal)
      $scope.set_ready(newVal)
    )

    $scope.mobile_view = window.innerWidth < 768

    $scope.set_active = (current_state) ->
      current_index = $scope.steps_mapping.indexOf(current_state)

      $scope.active_mapping = {}

      if current_index >= 0
        $scope.active_mapping.income = true
        $scope.step1 = step1_green_svg
      if current_index >= 1
        $scope.active_mapping.payment = true
        $scope.step2 = step2_green_svg
      if current_index >= 2
        $scope.active_mapping.complete = true
        $scope.step3 = step3_green_svg

    $scope.set_ready = (current_state) ->
      current_index = $scope.steps_mapping.indexOf(current_state)

      $scope.ready_mapping = {}

      if current_index > 0
        $scope.ready_mapping.income = true
        $scope.step1 = step_complete_svg
      if current_index > 1
        $scope.ready_mapping.payment = true
        $scope.step2 = step_complete_svg
      if current_index >= 2
        $scope.step3 = step_complete_svg
        $scope.ready_mapping.complete = true



// WEBPACK FOOTER //
// ./components/payment/payment.coffee